const PRODUCT_DATE = {
  7: '7 dias',
  15: '15 dias',
  30: '30 dias',
  60: '60 dias',
  120: '120 dias',
}

export { PRODUCT_DATE }
